import React from 'react'; 
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, useLocation } from "react-router-dom";
import { loginDetails } from '../Home/Login';
import { Crop } from '../../../node_modules/@mui/icons-material/index';


const CropsIntervalDays = () => {

    const navigate = useNavigate();
    const { state } = useLocation();
    const [flag, setFlag] = useState(false);
    const [CropsIntervalCodeValue, setCropsIntervalCodeValue] = useState("");
    const [cropsIntervalDaysData, setcropsIntervalDaysData] = useState("");
    const [stateValue, setStateValue] = useState("");
    const [statesData, setStatesData] = useState([]);
    const [districtValue, setDistrictValue] = useState("");
    const [districtData, setDistrictData] = useState([]);
    const [cropsValue, setCropsValue] = useState("");
    const [cropsData, setfetchCropsData] = useState([]);
    const [visibility, setVisibility] = useState("");
    const [isActive, setIsActive] = useState("");
    useEffect(() => {
        if (flag == true) {
            //fetchData2();
        }
    }, [flag])

    useEffect(() => {
        // useEffect to set defaultValue in dropdown meun
        if (state) {
          
            getStates()
            getCrops()
            setCropsIntervalCodeValue(state.cropsIntervalCode.cropIntervalCode)
            setCropsValue(state.cropsIntervalCode.cropCode)
            setcropsIntervalDaysData(state.cropsIntervalCode.cropIntervalDays)
            handleState(state.cropsIntervalCode.stateCode)
            handleDistrict(state.cropsIntervalCode.districtCode)            
            setDistrictValue(state.cropsIntervalCode.districtCode)
            setVisibility(state.cropsIntervalCode.visibility)
            setIsActive(state.cropsIntervalCode.isActive)
            setStateValue(state.cropsIntervalCode.stateCode)
        }
    }, [])

    function getStates() {
        const fetchStates = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Cropicstates`);
            setStatesData(result.data.dataContent);
        };
        fetchStates();
    }

    function getCrops() {
        const fetchCrops = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/crop`);
            setfetchCropsData(result.data.dataContent);
        };
        fetchCrops();
    }

    function handleCrops(value) {
        setCropsValue(value);
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "cropCode": Number(value)
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
    }
    function handleState(value) {
        if(value === "NA") { return}
        setStateValue(value);
        setDistrictData([])
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "stateCode": Number(value)
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Cropicdistrict`, requestOptions)
            .then(response => response.text())
            .then(result => setDistrictData(JSON.parse(result).dataContent))
            .catch(error => console.log('error', error));


    }
    function handleDistrict(value) {
        //setStateValue(value);
        //setDistrictValue([])
        setDistrictValue(value)

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "DistrictCode": Number(value)
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
    }

    function ValidateCropInteval() {
        console.log("datascd", stateValue, cropsValue , cropsIntervalDaysData)
        let valid = false;
        
   if(stateValue === "" || stateValue === "Choose...") {
    valid = false;
    alert("Select Any state")
    return;
   }else {
    valid = true
   }
   
   if(cropsValue === "" || cropsValue === "Choose...") {
    valid = false;
    alert("Select Any Crops")
    return;
   }else {
    valid = true
   }

   if(cropsIntervalDaysData === "" || cropsIntervalDaysData === "Choose...") {
    valid = false;
    alert("Enter Crops Interval Days Value")
    return;
   }else {
    valid = true
   }

   if(valid === true) {
    // console.log("valid9", valid)
     state ? UpdateUserDB() : AddNewCropsIntervalDays()
  }
   

    }

    function AddNewCropsIntervalDays() {
        let districtValueCode = districtValue ? districtValue : null
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var raw = JSON.stringify({
            "StateCode": stateValue,
            "DistrictCode": districtValueCode,
            "cropcode": cropsValue,
            "CropIntervalDays": cropsIntervalDaysData,
            "CreatedBy": localStorage.getItem("userCodeGlobal")
        });
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        }
        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/cropInterval/InsertCropInterval`, requestOptions)
            .then(response => response.text())
            .then((result) => {
                alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    setFlag(true);
                    navigate("/master/cropinterval")
                }
            })
            .catch(error => console.log('error', error));
    }

    function UpdateUserDB() {
        let myVisibility = visibility == "1" ? "Y" : "N";
        let myActive = isActive == "1" ? "Y" : "N";
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "cropIntervalCode": String(CropsIntervalCodeValue),
            "StateCode": String(stateValue),
            "DistrictCode": String(districtValue),
            "cropcode": cropsValue,
            "CropIntervalDays": cropsIntervalDaysData,
            "modifiedBy": "2",
            "MVisibility": myVisibility,
            "MIsActive": myActive,
        });

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        }

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/cropInterval/UpdateCropInterval`, requestOptions)
            .then(response => response.text())
            .then((result) => {
                alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    setFlag(true);
                    navigate("/master/cropinterval")
                }
            })
            .catch(error => console.log('error', error));
    }

    //async function fetchData2() {
    //    const result = await axios('/api/users');
    //    setUsersData(result.data.dataContent);
    //}
    function handleResetForm() {
        setcropsIntervalDaysData("");
        setCropsValue("");
        setDistrictValue("");
        setStateValue("");

  
      }
    return (
        <>
           
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Add New Crops Interval Days</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Crops Interval</li>
                            <li className="breadcrumb-item active">Add New Crops Interval Days</li>
                        </ol>
                    </nav>
                </div>
                <section className="section">
                    <div className="card dashboard">
                        <div className="card-body">

                            <form className="g-3 addNewUser">
                                <div className="row">
                                    <h5 className="formgrouping"> Add Crops Interval Days</h5>

                                    <div className="col-md-4">
                                        <label htmlFor="State" className="form-label">Select State</label>
                                        <select id="State" required className="form-select" onClick={getStates} onChange={(e) => handleState(e.target.value)} value={stateValue} >
                                            <option selected value="NA">Choose...</option>
                                            {statesData.map((item, id) => {
                                                return <option key={id} value={item.stateCode}> {item.stateName}</option>
                                            })}
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="District" className="form-label">Select District</label>
                                        <select id="District" className="form-select" onChange={(e) => handleDistrict(e.target.value)} value={districtValue}>
                                            <option selected>Choose...</option>

                                            {districtData.map((item, id) => {
                                                return <option key={id} value={item.districtCode}> {item.districtName}</option>
                                            })}
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="Crops" className="form-label">Select Crops</label>
                                        <select id="Crops" className="form-select" onClick={getCrops} onChange={(e) => handleCrops(e.target.value)} value={cropsValue}>
                                            <option selected>Choose...</option>

                                            {cropsData.map((item, id) => {
                                                return <option key={id} value={item.cropCode}> {item.cropName}</option>
                                            })}
                                        </select>
                                    </div>

                                    {
                                        state &&
                                        <>
                                            <div className="col-md-4">
                                                <div className="col-md-12">
                                                    <label htmlFor="visibility" className="form-label">Visibility</label>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-check form-check-inline" onClick={() => { setVisibility("1") }}>
                                                        <input className="form-check-input" type="radio" name="visibility" id="Yes" value="option1" checked={visibility == "1" ? 'true' : ''} />
                                                        <label className="form-check-label" for="Yes">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline" onClick={() => { setVisibility("0") }}>
                                                        <input className="form-check-input" type="radio" name="visibility" id="No" value="option2" checked={visibility == "0" ? 'true' : ''} />
                                                        <label className="form-check-label" for="No">No</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-sm-12">
                                                <div className="form-check" onClick={() => { setIsActive(isActive === "1" ? '1' : '0') }}>
                                                    <input className="form-check-input" type="checkbox" id="gridCheck1" checked={isActive == "1" ? 'true' : 'false'} />
                                                    <label className="form-check-label" for="gridCheck1"> Is Active </label>
                                                </div>
                                            </div>
                                        </>
                                    }
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label htmlFor="Days" className="form-label">Enter Days</label>
                                            <input id="Days" required className="form-control" placeholder="Enter Crop Interval Days" onChange={e => setcropsIntervalDaysData(e.target.value)} value={cropsIntervalDaysData }  />
                                        </div>
                                    </div>
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                                        {state ? <button className="btn btn-success me-md-2" type="button" onClick={ValidateCropInteval}>Update</button> : <button className="btn btn-success me-md-2" type="button" onClick={ValidateCropInteval}>Save</button>}

                                        <button className="btn btn-outline-primary" type="reset" onClick={handleResetForm}>Reset</button>
                                        <button className="btn btn-outline-danger" type="button" onClick={() => navigate("/master/cropinterval") }>Cancel</button>
                                        
                                    </div>


                                </div>
                            </form>
                        </div>
                    </div>




                </section>
            </main>
           
        </>
    )
}

export default CropsIntervalDays;